import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';

const withBannerMessages = Component =>
  graphql(
    gql`
      query withBannerMessages($countryCode: String!, $locale: String!) {
        banners(countryCode: $countryCode, locale: $locale) {
          message
          endDate
        }
      }
    `,
    {
      skip: ({ userInfo }) => {
        const info = userInfo || {};
        return !(info.country && info.locale);
      },
      options: ({ userInfo: { country, locale } }) => ({
        variables: { countryCode: country, locale }
      }),
      props: ({ data: { banners }, ownProps }) => ({
        ...ownProps,
        banners: banners ? banners.filter(Boolean) : []
      })
    }
  )(Component);

withBannerMessages.displayName = 'withBannerMessages';

export default withBannerMessages;
